import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useFetch from "../../Hooks/useFetch";
import useSave from "../../Hooks/useSave";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";

const Destination = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setView] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Add Products");

    const [categories, setCategories] = useState([]);
    const [counties, setCounties] = useState([]);
    const [subcounties, setSubcounties] = useState([]);
    const [wards, setWards] = useState([]);
    const [statuses, setStatuses] = useState([]);

    const url = "api/product";
    const { state, FetchAll } = useFetch(url + "/getAll?page=0&size=10");

    const fetchCategories = async () => {
        try {
            const response = await fetch("api/productCategory/getAll?page=0&size=10");
            if (!response.ok) throw new Error('Failed to fetch categories');
            const data = await response.json();
            setCategories(data);
            console.log("Fetched categories:", data);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const fetchCounties = async () => {
        try {
            const response = await fetch("api/counties/getAll");
            if (!response.ok) throw new Error('Failed to fetch counties');
            const data = await response.json();
            setCounties(data);
            console.log("Fetched counties:", data);
        } catch (error) {
            console.error("Error fetching counties:", error);
        }
    };

    const fetchStatuses = async () => {
        try {
            const response = await fetch("api/productStatus/getAll?page=0&size=10");
            if (!response.ok) throw new Error('Failed to fetch statuses');
            const data = await response.json();
            setStatuses(data);
            console.log("Fetched statuses:", data);
        } catch (error) {
            console.error("Error fetching statuses:", error);
        }
    };

    useEffect(() => {
        FetchAll();
        fetchCategories();
        fetchCounties();
        fetchStatuses();
    }, []);

    useEffect(() => {
        if (state.data) {
            console.log("Fetched data:", state.data);
        }
    }, [state.data]);

    const handleOpenModal = () => {
        setInputs({});
        setOpen(true);
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };

    const handleEdit = () => {
        if (inputs.id) {
            setOpen(true);
            setUpdate(true);
            setView(false);
        } else {
            alert("Select a record to edit");
        }
    };

    const handleView = () => {
        if (inputs.id) {
            setView(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to view");
        }
    };

    const handleSelect = (k) => {
        setInputs({});
        setInputs(k);
    };

    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setView(false);
        setUpdate(false);
    };

    const HandleSave = () => {
        useSave(url, inputs);
        FetchAll();
    };

    const HandleUpdate = () => {
        useUpdate(url + "/" + inputs.id, inputs);
        FetchAll();
    };

    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate();
        } else {
            HandleSave();
        }
    };

    const CallDeleteHook = () => {
        useDelete(url + "/" + inputs.id);
        FetchAll();
    };

    const HandleDelete = (event) => {
        event.preventDefault();
        if (inputs.id) {
            CallDeleteHook();
        } else {
            alert("Select a record to delete");
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        return date.toISOString().slice(0, 16);
    };

    const handleCountyChange = async (event) => {
        const countyId = event.target.value;
        setInputs((inputs) => ({ ...inputs, countyId }));

        try {
            const subcountiesResponse = await fetch(`api/subcounties/getAll?countyId=${countyId}`);
            if (!subcountiesResponse.ok) throw new Error('Failed to fetch subcounties');
            const subcounties = await subcountiesResponse.json();
            setSubcounties(subcounties);
        } catch (error) {
            console.error("Error fetching subcounties:", error);
        }
    };

    const handleSubcountyChange = async (event) => {
        const subCountyId = event.target.value;
        setInputs((inputs) => ({ ...inputs, subCountyId }));

        try {
            const wardsResponse = await fetch(`api/wards/getAll?subCountyId=${subCountyId}`);
            if (!wardsResponse.ok) throw new Error('Failed to fetch wards');
            const wards = await wardsResponse.json();
            setWards(wards);
        } catch (error) {
            console.error("Error fetching wards:", error);
        }
    };

    const ColumnData = [
        { label: "Code", field: "code", sort: "asc" },
        { label: "Name", field: "name", sort: "asc" },
        { label: "Description", field: "description", sort: "asc" },
        { label: "Town", field: "town", sort: "asc" },
        { label: "Email", field: "email", sort: "asc" },
        { label: "Website", field: "website", sort: "asc" },
        { label: "Category", field: "category.name", sort: "asc" },
        { label: "County", field: "ward.subCounty.counties.name", sort: "asc" },
        { label: "Subcounty", field: "ward.subCounty.name", sort: "asc" },
        { label: "Ward", field: "ward.name", sort: "asc" },
        { label: "Status", field: "status.name", sort: "asc" },
        { label: "Created At", field: "createdAt", sort: "asc" },
        { label: "Created By", field: "createdBy", sort: "asc" },
    ];

    let RowData = [];
    const rows = state.data?.product || [];

    if (rows.length > 0) {
        rows.forEach((k) => {
            const Rowdata = {
                clickEvent: () => handleSelect(k),
                code: k.code,
                name: k.name,
                description: k.description,
                town: k.town,
                email: k.email,
                website: k.website,
                category: k.category.name,
                county: k.ward.subCounty.counties.name,
                subcounty: k.ward.subCounty.name,
                ward: k.ward.name,
                status: k.status.name,
                createdAt: formatDate(k.createdAt),
                createdBy: k.createdBy,
            };
            RowData.push(Rowdata);
        });
    }

    const ActionsBtn = () => {
        return (
            <div>
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-success p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandleDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null}
                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
                </button>
            </div>
        );
    };

    return (
        <div id="content" className="content">
            <ol className="breadcrumb float-xl-right">
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Products</li>
            </ol>
            <h1 className="page-header mb-3">Products</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div className="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                        {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleEdit}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Edit &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Remove") ? (
                            <button
                                onClick={HandleDelete}
                                className="btn btn-danger p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Delete &nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={RowData} columns={ColumnData} />
                    </div>
                </div>
            </div>

            <Modal visible={open} width="60%" height="50%" effect="fadeInUp">
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
                    </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 font-weight-bold text-blue">
                                Products
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />

                                {view ? (
                                    <div>
                                        <h3>Products</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Code:</td>
                                                    <td>{inputs.code}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Name:</td>
                                                    <td>{inputs.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Description:</td>
                                                    <td>{inputs.description}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Town:</td>
                                                    <td>{inputs.town}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Email:</td>
                                                    <td>{inputs.email}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Website:</td>
                                                    <td>{inputs.website}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Category:</td>
                                                    <td>{inputs.categoryId}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">County:</td>
                                                    <td>{inputs.countyId}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Subcounty:</td>
                                                    <td>{inputs.subCountyId}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Ward:</td>
                                                    <td>{inputs.wardId}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Status:</td>
                                                    <td>{inputs.statusId}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created At:</td>
                                                    <td>{inputs.createdAt ? formatDate(inputs.createdAt) : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created By:</td>
                                                    <td>{inputs.createdBy}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="code" className="font-weight-bold">
                                                        Code
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="code"
                                                        required
                                                        value={inputs.code || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                        Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        required
                                                        value={inputs.name || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                        Description
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        required
                                                        value={inputs.description || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="town" className="font-weight-bold">
                                                        Town
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="town"
                                                        required
                                                        value={inputs.town || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="email" className="font-weight-bold">
                                                        Email
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        required
                                                        value={inputs.email || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="website" className="font-weight-bold">
                                                        Website
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="website"
                                                        required
                                                        value={inputs.website || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="categoryId" className="font-weight-bold">
                                                        Category
                                                    </label>
                                                    <select
                                                        className="form-control"
                                                        name="categoryId"
                                                        required
                                                        value={inputs.categoryId || ""}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Category</option>
                                                        {categories.map((category) => (
                                                            <option key={category.id} value={category.id}>
                                                                {category.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="countyId" className="font-weight-bold">
                                                        County
                                                    </label>
                                                    <select
                                                        className="form-control"
                                                        name="countyId"
                                                        required
                                                        value={inputs.countyId || ""}
                                                        onChange={handleCountyChange}
                                                    >
                                                        <option value="">Select County</option>
                                                        {counties.map((county) => (
                                                            <option key={county.id} value={county.id}>
                                                                {county.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="subCountyId" className="font-weight-bold">
                                                        Subcounty
                                                    </label>
                                                    <select
                                                        className="form-control"
                                                        name="subCountyId"
                                                        required
                                                        value={inputs.subCountyId || ""}
                                                        onChange={handleSubcountyChange}
                                                    >
                                                        <option value="">Select Subcounty</option>
                                                        {subcounties.map((subcounty) => (
                                                            <option key={subcounty.id} value={subcounty.id}>
                                                                {subcounty.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="wardId" className="font-weight-bold">
                                                        Ward
                                                    </label>
                                                    <select
                                                        className="form-control"
                                                        name="wardId"
                                                        required
                                                        value={inputs.wardId || ""}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Ward</option>
                                                        {wards.map((ward) => (
                                                            <option key={ward.id} value={ward.id}>
                                                                {ward.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="statusId" className="font-weight-bold">
                                                        Status
                                                    </label>
                                                    <select
                                                        className="form-control"
                                                        name="statusId"
                                                        required
                                                        value={inputs.statusId || ""}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Status</option>
                                                        {statuses.map((status) => (
                                                            <option key={status.id} value={status.id}>
                                                                {status.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekDayOpen" className="font-weight-bold">
                                                        Weekday Open
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekDayOpen"
                                                        required
                                                        value={inputs.weekDayOpen || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekDayClosingHour" className="font-weight-bold">
                                                        Weekday Close
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekDayClosingHour"
                                                        required
                                                        value={inputs.weekDayClosingHour || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekendOpeningHour" className="font-weight-bold">
                                                        Weekend Open
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekendOpeningHour"
                                                        required
                                                        value={inputs.weekendOpeningHour || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekendClosingHours" className="font-weight-bold">
                                                        Weekend Close
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="weekendClosingHours"
                                                        required
                                                        value={inputs.weekendClosingHours || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="holidayOpeningHours" className="font-weight-bold">
                                                        Holiday Open
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="holidayOpeningHours"
                                                        required
                                                        value={inputs.holidayOpeningHours || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="holidayClosingHours" className="font-weight-bold">
                                                        Holiday Close
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="holidayClosingHours"
                                                        required
                                                        value={inputs.holidayClosingHours || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="createdAt" className="font-weight-bold">
                                                        Created At
                                                    </label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        name="createdAt"
                                                        required
                                                        value={inputs.createdAt ? formatDate(inputs.createdAt) : ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="createdBy" className="font-weight-bold">
                                                        Created By
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="createdBy"
                                                        required
                                                        value={inputs.createdBy || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Destination;
